import cx from 'classnames'
import React, { useEffect, useState } from 'react'

import { staticAsset } from '@js/common/utils'

import MariaChat from '@f/components/MariaChat'
import CTA from '@f/elements/CTA'
import FormCheckbox from '@f/elements/FormCheckbox'

const OutfittersContent = props => {
  const [selectedOutfitters, setSelectedOutfitters] = useState([])
  const [outfitterUrl, setOutfitterUrl] = useState('')

  const handleCheckbox = categoryId => {
    setSelectedOutfitters(previousOutfitters => {
      let selectedOutfitters

      if (previousOutfitters.indexOf(categoryId) >= 0) {
        selectedOutfitters = previousOutfitters.filter(el => el !== categoryId)
      } else {
        selectedOutfitters = previousOutfitters.concat(categoryId)
      }

      return selectedOutfitters
    })
  }

  useEffect(() => {
    setOutfitterUrl(
      selectedOutfitters.length > 0
        ? `?categories=${selectedOutfitters.join(',')}`
        : ''
    )
  }, [selectedOutfitters])

  const isConversionFunnel = Boolean(props.funnelVariant)

  return (
    <div
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel'
      )}>
      <div className='RequestWizard-top'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            {props.heading}
          </div>
          <div className='[ f-t-centre f-t-body f-c-fo-pri f-p-t-005 f-p-h-080:m ]'>
            {props.subHeading}
          </div>
        </div>

        <div className='RequestWizard-content'>
          <MariaChat
            message={
              props.mariaChatMessage ? (
                props.mariaChatMessage
              ) : (
                <>
                  <strong className='[ f-d-bl f-m-b-005 f-t-mini ]'>
                    Maria von Fertighaus
                  </strong>
                  <div>
                    Interessieren Sie sich auch für Produkte rund ums Haus?
                  </div>
                  Fragen Sie nun Produktkataloge an. Bequem & Kostenlos.
                </>
              )
            }
          />

          <div className='[ f-d-flr f-m-v-020 f-t-centre ] RequestWizard-block-options-wrapper'>
            <FormCheckbox
              className='[ f-d-bl f-p-t-020 f-m-a-005 f-c-fo-pri f-c-ba-whi f-c-bo-neu025 f-fl-half ]'
              label='Küchen'
              name='outfitter'
              labelClassNames='[ f-d-bl f-p-v-005 ]'
              theme='image-label-large'
              inputProps={{ 'data-sel': 'ckbx-ktcn' }}
              image={{
                path: staticAsset('images/kitchen.svg'),
                parameters: {
                  className: '[ f-p-b-020 ]',
                  style: {
                    height: 64
                  }
                }
              }}
              onChange={() => handleCheckbox(1)}
              wtData={{
                valueOverride: 'Küchen'
              }}
            />
            <FormCheckbox
              className='[ f-d-bl f-p-t-020 f-m-a-005 f-c-fo-pri f-c-ba-whi f-c-bo-neu025 f-fl-half ]'
              label='Garagen & Carports'
              name='outfitter'
              labelClassNames='[ f-d-bl f-p-v-005 ]'
              theme='image-label-large'
              inputProps={{ 'data-sel': 'ckbx-grge' }}
              image={{
                path: staticAsset('images/garage.svg'),
                parameters: {
                  className: '[ f-p-b-020 ]',
                  style: {
                    height: 64
                  }
                }
              }}
              onChange={() => handleCheckbox(2)}
              wtData={{
                valueOverride: 'Garagen & Carports'
              }}
            />
          </div>
        </div>
      </div>

      <div className='RequestWizard-bottom'>
        <CTA
          type='block-primary'
          tag='a'
          href={`/produkte/kataloge/${outfitterUrl}`}
          className='[ f-m-h-auto f-m-t-020 ] is-block:s'
          data-sel='outfitter-list'>
          Hersteller auswählen
        </CTA>
      </div>
    </div>
  )
}

export default OutfittersContent
